import { getTitleId } from 'components/Pages/Admin/Page/Landing/utils';
import { BlockProvider } from 'components/shared/BlockProvider';

import { usePageContext } from '../../context';
import BlockWrapper from '../blocks/BlockWrapper';
import { BlockContextProvider, useBlockContext } from './context';
import { IBlockProps } from './types';

const Block = (props: IBlockProps) => {
  const { index } = useBlockContext();
  const { pageHeadlineRef, data } = usePageContext();
  const blockId = getTitleId(data.headline, index.join())!;

  return (
    <BlockProvider blockId={blockId} pageHeaderRef={pageHeadlineRef}>
      <BlockContextProvider value={props}>
        <BlockContextConsumer />
      </BlockContextProvider>
    </BlockProvider>
  );
};

const BlockContextConsumer = () => {
  const { config } = useBlockContext();

  const Component = config?.Component;
  if (!Component) return null;

  return (
    <BlockWrapper hiddenTrash={false}>
      {/* @ts-ignore */}
      <Component />
    </BlockWrapper>
  );
};

export default Block;
